<template>
	<div class="app">
		<jycheader></jycheader>
		<!--:navIndex="0"-->
		<div style="width:100%;background-color: #f5f5f5">
			<div class="myfoods-pay-box">
				<!-- <div class="order-info">选择收货地址</div>
				<div class="receiver-info-box" v-if="!chooseFlag">
					<div class="header1we">
						<div class="headerwe-neiwe">
							<div class="headerwe-div" @click="add_address">
								<div style="padding:0 20px">
									<div class="dis-between order-lin2">
										<div style="color:#ffffff">1</div>
										<div class="order-p"></div>
									</div>
									<div class="dis-cen">
										<div class="dis" style="margin-top:15px">
											<div style="color:#ffffff">1</div>
											<img class="orin-img" src="../../assets/image/img/newimg/jia.png" />
											<div style="margin:auto 0">新增收货地址</div>
										</div>
									</div>
								</div>
								<div class="dis-between order-pos" style="color:#ffffff;margin-top:21px">1</div>
							</div>

							<div
								v-for="(item,index) in addressList"
								:key="index"
								class="headerwe-div"
								:class="item.v_act?'headerwe-act':''"
								@click="chooseAddress(item.id, index)"
							>
								<div style="padding:0 20px">
									<div class="dis-between order-lin">
										<div style="width:70%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.lngLatAddress}}</div>
										<div class="order-p" v-if="item.isDefault">默认地址</div>
										<div class="order-p" v-else></div>
									</div>
									<div
										style="margin-top:13px;width: 100%; overflow:hidden;white-space:nowrap; text-overflow:ellipsis;"
									>{{item.provinceName}}{{item.cityName}}{{item.regionName}}{{item.address}}</div>
                                    <div style="margin-top:5px">{{item.userName}}&nbsp;&nbsp;{{item.phone}}</div>
                                </div>
								<div class="dis-between order-pos" style="margin-top:8px" v-if="item.v_act">
									<div style="margin-left:20px;color:#069338" @click="add_address">修改</div>
									<img class="headerwe-img" src="../../assets/image/img/newimg/dagou.png" />
								</div>
								<div v-else class="dis-between order-pos" style="color:#ffffff;margin-top:8px">1</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="dis-between" style="background-color:#ffffff;padding:20px 20px;margin-top:29px "> 
                    <div style="font-size: 16px;color: #333333;">
                        <div style="font-family: Microsoft YaHei-Bold, Microsoft YaHei;font-weight: bold;">{{newAddressListObj.lngLatAddress}}</div>
                        <div style="margin:12px 0">{{newAddressListObj.address}}</div>
                        <div class="dis">{{newAddressListObj.userName}}
                            <span style="margin: 0 10px" v-if="newAddressListObj.sex == 1">先生</span><span v-else>女士</span>
                            <div>{{newAddressListObj.phone}}</div>
                        </div>
                    </div>
                    <div style="color:#ffffff;text-align:center;font-size:13px;line-height:21px;width:40px;height:21px;background:#23C959;border-radius:4px;opacity:1;">默认</div>

                </div>
                <div style="height:22px"></div>
				<div class="order-info" style="margin-bottom:0.8125rem;font-size: 16px;">商品详情</div>
				<div class="mycart-container-item" style="margin-bottom:30px;min-height:10rem">
					<div class="mycart-header-box">
						<div class="mycart-product" style="text-align:left;width:25rem">商品信息</div>
                        <div class="mycart-product" style="text-align:center;width:12.5rem">规格</div>
						<div class="mycart-foods-price">单价</div>
						<div class="mycart-foods-num">数量</div>
						<div class="mycart-subtotal" style="width:12.5rem">小计（元）</div>
					</div>
					<div class="goods-info-item" v-for="(item,index) in orderList" :key="index">
						<div class="goods-img">
							<img style="margin:20px 0" :src="item.cover" alt />
						</div>
						<div class="goods-name" style="width:20rem">{{item.name}}<span style="margin-left:10px" :class="item.shopType == 1?'or-new-num-col':'or-new-num-col2'">{{item.shopTypeName}}</span><span class="or-new-num-col2" style="background:#ff8500;margin-left:10px" v-if="item.goodsType == 2">积分</span></div>
						<div class="goods-num-box" style="width:10.5rem;color:#000000">{{item.goodsSize}}</div>
                        <div class="goods-price" v-if="item.shopType == 1">￥{{item.price}}元<span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.integral}}积分</span></div>
                        <div class="goods-price" v-else-if="item.banJia > 0">￥{{item.banJia}}元<span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.integral}}积分</span>&nbsp;<div style="text-decoration:line-through;color:#929292">￥{{item.price}}</div></div>
                        <div class="goods-price" v-else>￥{{item.discountPrice}}元<span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.integral}}积分</span>&nbsp;<div style="text-decoration:line-through;color:#929292">￥{{item.price}}</div></div>
                        
                        <div v-if="item.goodsType == 2" class="goods-num-box"><div style="text-align:center;color:#000000;width:30px;height:20px;background-color:#f5f5f5">{{item.num}}</div></div>
                        <div v-else class="goods-num-box">
							<div class="goods-jian" @click="less(item,index)">-</div>
							<input type="text" v-model="item.num" disabled="disabled"/>
							<div class="goods-add" @click="add(item,index)">+</div>
						</div>
						<div class="goods-count-box" style="width:15.625rem">
							<span>￥{{item.allPrice}}</span><span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.v_integralSum}}积分</span>
						</div>
					</div>
                    <div style="width:100%;border-top:1px solid #f1f1f1"></div>
				</div>

                <div v-if="paly_type !== 3" class="order-info" style="margin-bottom:0.8125rem;font-size: 16px;">配送方式</div>
                <div v-if="paly_type !== 3" style="background-color: #ffffff;padding: 20px 20px 10px 20px">
                    <div class="dis">
                        <div class="order-but-peisong" :class="[peisong_type == 1?'order-but-act-bac':'']" @click="peisongClick(1)">无需配送</div>
                        <div style="width:36px"></div>
                        <div class="order-but-peisong" :class="[peisong_type == 2?'order-but-act-bac':'']" @click="peisongClick(2)">配送到家</div>
                    </div>
                    <div style="height:10px"></div>
                    <div v-if="peisong_type == 1">
                        <div v-for="(item2,index2) in orderList" :key="index2">
                            <div style="border-bottom: 1px solid #f5f5f5;margin:10px 0"></div>
                            <div class="dis-between" style="margin:10px 0">
                                <div class="dis">
                                    <img style="width:70px;height:70px;" :src="item2.cover" alt />
                                    <div style="margin:auto 20px">
                                        <div style="font-size:16px;font-family: Microsoft YaHei-Bold, Microsoft YaHei;font-weight: bold;color: #333333;margin-top:10px">{{item2.shopName}}<span style="margin-left:20px">{{item2.shopPhone}}</span></div>
                                        <div style="font-size: 16px;font-family: Microsoft YaHei-Regular, Microsoft YaHei;font-weight: 400;color: #333333;margin:16px 0 0 0">{{item2.shopAddress}}</div>
                                    </div>
                                </div>
                                <!--<div style="width:50px;height:50px;margin:auto 0"><img src="../../assets/image/img/newimg45.png" alt /></div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <div style="height:22px"></div>
                <!-- 新增 --------------------------------------------------------------->
                <div v-if="is_categoryTypeFour" class="order-info" style="margin-bottom:0.8125rem;font-size: 16px;">餐具和备注</div>
                <div v-if="is_categoryTypeFour" style="background-color: #ffffff;padding: 0 20px">
                    <div class="dis-between" style="line-height:53px;border-bottom: 1px solid #F7F6FB;cursor: pointer;" @click="openTablewareClick">
                        <div>餐具数量</div>
                        <div class="dis">
                            <div v-if="tableware_value" class="orderinfo-box-p" style="color:#333333"><span style="color:#FF6B30;margin-right:10px">{{tableware_value}}</span>份餐具</div>
                            <div v-else-if="istablewareValue" class="orderinfo-box-p" style="color:#333333">{{istablewareValue}}</div>
                            <div v-else class="orderinfo-box-p">选择餐具</div>
                            <img class="orderinfo-box-img" src="../../assets/image/jiantou.png" />
                        </div>
                    </div>
                    <div class="dis-between" style="line-height:53px;cursor:pointer" @click="remarkClick">
                        <div>备注</div>
                        <div class="dis">
                            <div v-if="remark_value" class="orderinfo-box-p" style="color:#333333;">{{remark_value}}</div>
                            <div v-else class="orderinfo-box-p">填写备注</div>
                            <img class="orderinfo-box-img" src="../../assets/image/jiantou.png" />
                        </div>
                    </div>
                </div>
                <!---->
                <div class="reg-popup-bac req-popup-pos" v-if="is_tablewarePopup || is_categoryTypeRemark"></div>
                <div class="req-popup-pos reg-popup-wid dis-cen" v-if="is_tablewarePopup">
                    <div class="reg-popup-box" style="width: 518px;height:auto;border-radius: 10px;">
                        <div class="dis-between"><div class="tableware-p">是否需要餐具</div><div class="tableware-p2" @click="closePopupClick" style="color:#23C959">确定</div></div>
                        <div class="dis-between">
                            <div class="tableware-box" :class="istableware?'tableware-box-act':''" @click="setSonBox(1)">需要餐具</div>
                            <div class="tableware-box" :class="!istableware?'tableware-box-act':''" @click="setSonBox(2)">无需餐具</div>
                        </div>
                        <div v-if="istableware">
                            <div class="tableware-box-title" style="margin:30px 0 24px 0">选择餐具数量</div>
                            <div class="dis-between tableware-box-num">
                                <div style="margin:auto 0"><span style="color:#FF6B30;margin-right:10px">{{tableware_value}}</span>份餐具</div>
                                <div class="dis">
                                    <img @click="jianimgClick" class="tableware-box-img" src="../../assets/image/jianimg.png" />
                                    <div class="tableware-box-hui">{{tableware_value}}</div>
                                    <img @click="jiaimgClick" class="tableware-box-img" src="../../assets/image/jiaimg.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!----->
                <div class="req-popup-pos reg-popup-wid dis-cen" v-if="is_categoryTypeRemark">
                    <div class="reg-popup-box" style="width: 560px;height:auto;border-radius: 10px;padding:16px 16px">
                        <div class="dis-between"><div class="tableware-p"></div><img @click="closePopupRemarkClick" src="../../assets/image/chaimg.png" /></div>
                        <div style="padding:24px 24px">
                            <div class="tableware-textarea-box"><el-input type="textarea" :rows="8" placeholder="请输入" v-model="remark_value">
                            </el-input></div>
                            <div class="tableware-botton-p">快捷标签</div>
                            <div class="dis">
                                <div v-for="(item8, index8) in remark_tab" :key="index8">
                                    <div class="tableware-remark-box" :class="[item8 == remark_value?'tableware-remark-act':'', index8 == 4?'act-mar':'']" @click="remarkTabClick(item8)">{{item8}}</div>
                                </div>
                            </div>

                            <div v-if="remark_value" class="tableware-botton" @click="closePopupRemarkClick">确认</div>
                            <div v-else class="tableware-botton2">确认</div>
                        </div>
                    
                    </div>
                </div>
                <!---------------------------->
                <div style="height:34px"></div>
                <div style="background-color: #ffffff;padding: 0 20px;">
                    <div style="height:20px"></div>
                    <div class="dis-between order-info-new-box-p" style="height:56px;background:#ffffff;padding:0 24px;box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.1607843137254902);border-radius: 0px 0px 0px 0px;opacity: 1;">
                        <div class="dis">
                            <div class="order-info-new-box-p" style="margin:auto 0;font-size:16px;color:#434343"><span style="font-family: Microsoft YaHei-Bold, Microsoft YaHei;font-weight: bold;color: #333333;">{{orderList.length}}件商品</span>&nbsp;&nbsp;&nbsp;<span style="color:#A2ADA6">商品小计：</span> ￥{{totalprice}}<span v-if="is_integral">&nbsp;&nbsp;/&nbsp;&nbsp;{{integralAllSum}}积分</span></div>
                            <div style="margin:auto 0 auto 31px;font-size:16px;">
                                配送费：
                                <span>{{shopprice}}元</span>
                            </div>
                        </div>
                        <div style="margin:auto 0;font-size:16px;color:#434343">
                            实付：
                            <span style="color:#D9161C">￥{{payprice}}</span>
                            <span v-if="is_integral" style="color:#D9161C">&nbsp;&nbsp;/&nbsp;&nbsp;{{integralAllSum}}积分</span>
                        </div>
                    </div>
                    <div style="height:30px"></div>
                    <div class="dis"><div style="width: 4px;height: 20px;background: #11D165"></div><div style="height:20px;line-height:20px;margin:auto 0 auto 16px;font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #434343;">可用余额：¥ {{myBalance.balance}}元</div></div>
                    <div style="height:30px" v-if="is_integral"></div>
                    <div class="dis" v-if="is_integral"><div style="width: 4px;height: 20px;background: #11D165"></div><div style="height:20px;line-height:20px;margin:auto 0 auto 16px;font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #434343;">可用积分：{{myBalance.tokenmoney}}分</div></div>
                    <div style="height:30px"></div>
                    <div class="dis-between order-info-new-box-p">
                        <div class="dis">
                            <div @click="typeClick(1)" class="dis order-but-box" :class="paly_type == 1?'order-but-act':''">
                                <img class="order-but-ride" v-if="paly_type == 1" src="../../assets/image/iocn/tuoyuan1.png" />
                                <img class="order-but-ride" v-else src="../../assets/image/iocn/tuoyuan2.png" />
                                <div class="order-but-box-p" :class="paly_type == 1?'order-but-act-col':''">&nbsp;&nbsp;扫码支付</div>
                            </div>
                            <div style="width:30px"></div>
                            <div @click="typeClick(2)" class="dis order-but-box" :class="paly_type == 2?'order-but-act':''">
                                <img class="order-but-ride" v-if="paly_type == 2" src="../../assets/image/iocn/tuoyuan1.png" />
                                <img class="order-but-ride" v-else src="../../assets/image/iocn/tuoyuan2.png" />
                                <div class="order-but-box-p" :class="paly_type == 2?'order-but-act-col':''">&nbsp;&nbsp;余额支付</div>
                            </div>
                            <div style="width:30px" v-if="is_integral"></div>
                            <div @click="typeClick(3)" v-if="is_integral" class="dis order-but-box" :class="paly_type == 3?'order-but-act':''">
                                <img class="order-but-ride" v-if="paly_type == 3" src="../../assets/image/iocn/tuoyuan1.png" />
                                <img class="order-but-ride" v-else src="../../assets/image/iocn/tuoyuan2.png" />
                                <div class="order-but-box-p" :class="paly_type == 3?'order-but-act-col':''">&nbsp;&nbsp;积分支付</div>
                            </div>
                            <div style="width:30px"></div>
                            <div @click="typeClick(5)" class="dis order-but-box" :class="paly_type == 5?'order-but-act':''" style="width:170px">
                                <img class="order-but-ride" v-if="paly_type == 5" src="../../assets/image/iocn/tuoyuan1.png" />
                                <img class="order-but-ride" v-else src="../../assets/image/iocn/tuoyuan2.png" />
                                <div class="order-but-box-p" :class="paly_type == 5?'order-but-act-col':''">&nbsp;&nbsp;消费券支付</div>
                            </div>
                            <div style="width:30px"></div>
                            <div @click="typeClick(6)" v-if="is_integral" class="dis order-but-box" :class="paly_type == 6?'order-but-act':''" style="width:170px;margin-top:20px">
                                <img class="order-but-ride" v-if="paly_type == 6" src="../../assets/image/iocn/tuoyuan1.png" />
                                <img class="order-but-ride" v-else src="../../assets/image/iocn/tuoyuan2.png" />
                                <div class="order-but-box-p" :class="paly_type == 6?'order-but-act-col':''">&nbsp;&nbsp;通用券支付</div>
                            </div>
                            
                        </div>
                        <div class="dis-cen">
                            <div class="soon-pay-btn" v-if="btnFlag" @click="immediatelyPay">提交订单</div>
                        </div>
                    </div>
                    <div style="height:40px"></div>
                </div>
			</div>
		</div>
		<!-- 扫码支付 -->
		<div class="pay-code-box" v-show="submitFlag">
			<div class="pay-code-content">
				<div class="pay-code-top">
					<p>付款</p>
					<p @click="closeCode">×</p>
				</div>
				<div class="pay-code-price">
					金额:
					<!-- <span>￥{{totalprice}}</span> -->
					<span>￥{{payprice}}</span>
				</div>
				<div class="pay-code-tips">请使用以下支付方式扫码付款</div>
				<div class="paytype-item">
					<img src="../../assets/image/img/购物车/sub-gs.png" alt />
					<img src="../../assets/image/img/购物车/sub-wx.png" alt />
					<img src="../../assets/image/img/购物车/sub-zfb.png" alt />
				</div>
				<!-- 支付二维码 -->
				<div style="text-align:center">
					<vue-qr :text="qr_text" :size="150" />
				</div>

				<div class="success-btn" @click="paySuccess">支付完成</div>
			</div>
		</div>

        <!--请输入支付密码-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_zhifuPopup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_zhifuPopup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div @click="wjpasswordClick" style="color:#11D165;cursor: pointer;">设置支付密码</div>
                    <div style="font-size: 22px;">支付密码</div>
                    <div class="dis-end" style="width:96px"><img class="reg-popup-box-close" style="cursor: pointer;" @click="closePopupImgClick" src="../../assets/image/iocn/close.png" /></div>
                </div>
                <div style="font-size: 18px;text-align: center;margin-top:19px">请输入支付密码，以验证身份</div>
                <div id="payPwd" style="margin: 60px 15%">
                    <input ref="pwd" type="password" maxlength="6" v-model="msg"  style="position: absolute;z-index: -1;left:-100%;opacity: 0"/>
                    <ul class="pwd-wrap" @click="focus">
                    <li><i v-if="msgLength > 0"></i></li>
                    <li><i v-if="msgLength > 1"></i></li>
                    <li><i v-if="msgLength > 2"></i></li>
                    <li><i v-if="msgLength > 3"></i></li>
                    <li><i v-if="msgLength > 4"></i></li>
                    <li><i v-if="msgLength > 5"></i></li>
                    </ul>
                </div>
                <div class="dis-cen">
                    <div v-if="!is_loading" class="withdra-color withdra-but" @click="checkClick">提交</div>
                    <div v-else class="withdra-color withdra-but" style="background-color: #cacaca;">加载中...</div>
                </div>
            </div>
        </div>

		<jycfooter></jycfooter>
	</div>
</template>

<script>
import jycheader from "../header.vue"
import jycfooter from "../bottom.vue"
import vueQr from "vue-qr"
const token = ""
export default {
	data() {
		return {
            is_loading: false,
            is_zhifuPopup: false,
            msg:'',
            msgLength: 0,
			btnFlag: true,
			shopprice: 0,
			subtotal: 0, //小计
			goodstotal: 0, //商品金额
			moreFlag: false,
			pagesize: 50,
			totalLength: 0,
			goodsNum: 1, //商品数量
			submitFlag: false,
			addressList: [],
			newAddressListObj: {},
			chooseFlag: false,
			username: "",
			userphone: "",
			address: "",
			addressId: 0,
			orderList: [],
			shopId: 0, //店铺id
			goodsId: 0, //商品id
			addressFlag: false, //判断用户有没有选择地址
			addressIds: 0,
			cartId: 0, //购物车id
			codeurl: "",
            integralAllSum: 0,
			totalprice: 0, //总价
			sendprice: 0, //运费
			payprice: 0, //应付金额
			payList: [],
			qr_text: "",
            is_integral: false,
			// +-----------------------------------------
			act_addressId: 0,
            paly_type: 1,
            myBalance: '--',
            peisong_type: '',
			newPayList: [],
            remark_value: '',
            istableware: false,
            istablewareValue: '',
            tableware_value: 0,
            is_tablewarePopup: false,
            is_categoryTypeFour: 0,
            is_categoryTypeRemark: false,
            remark_tab: ['不吃辣', '少放辣', '多放辣', '不吃蒜', '不吃葱', '不吃香菜']
		}
	},
	components: {
		jycheader,
		jycfooter,
		vueQr
	},
    created() {
        window.scroll(0, 0)
        this.getBalance()
        this.setSonBox(2)
    },
	mounted() {
		this.getaddress(this.pagesize)
		this.getorderInfo()
		this.getAllPrice(this.orderList)
		this.token = localStorage.getItem("token")
		this.getCode()
		//获取收获地址id

		if (this.orderList[0].goodsType == 2) this.peisong_type = 1
	},
    watch:{
        msg(curVal){
            if(/[^\d]/g.test(curVal)){
            this.msg = this.msg.replace(/[^\d]/g,'');
            }else{
                this.msgLength = curVal.length;
            }
        },
    },
	methods: {
        openTablewareClick() {
            this.is_tablewarePopup = true
        },
        closePopupClick() {
            this.is_tablewarePopup = false
        },
        setSonBox(val) {
            if (val == 1) {
                this.istableware = true
                this.istablewareValue = ''
                this.tableware_value = 1
            } else {
                this.istablewareValue = '无需餐具'
                this.istableware = false
                this.tableware_value = 0
            }
        },
        jianimgClick() {
            if (this.tableware_value == 1) {
                this.checkTips("至少1份餐具", "warning")
                return
            }
            this.tableware_value = this.tableware_value - 1
        },
        jiaimgClick() {
            this.tableware_value = this.tableware_value + 1
        },
        remarkClick() {
            this.is_categoryTypeRemark = true
        },
        closePopupRemarkClick() {
            this.is_categoryTypeRemark = false
        },
        remarkTabClick(value){
            this.remark_value = value
        },
        // +---------------------------------------------------
        peisongClick(val) {

			if (this.orderList[0].goodsType == 2) {
				this.peisong_type = 1
				this.checkTips("积分商品无需配送!", "warning")
				return
			}

            if (val == 1) {
                this.shopprice = 0
                this.getAllPrice()
            }
            if (val == 2) {
				if (this.totalprice < this.orderList[0].deliveryStartAt) {
					let newMsg = '低于' + this.orderList[0].deliveryStartAt + '元暂不支持配送!'
					this.checkTips(newMsg, "warning")
					return
				}
                let marVal = 0
				let marketActObj = JSON.parse(localStorage.getItem("marketActObj"))
				if (marketActObj) marVal = marketActObj.lng + ',' + marketActObj.lat
				let AddressActObj = JSON.parse(localStorage.getItem("AddressActObj"))
				let reqParam =  {Preice: this.totalprice, MarketLngLat: marVal, UserLngLat: AddressActObj.lngLat}
				// 名小吃、本地小吃 追加参数 +-----------------------------------------
                if (this.orderList[0].categoryType == 4 || this.orderList[0].categoryType == 5) {
                    reqParam.MarketLngLat = this.orderList[0].shopLngLat
                    reqParam['categorytype'] = this.orderList[0].categoryType
                }
                
                this.$api.order.GetOrderDeliveryFee(reqParam).then(res => {
					if (res.data.code == 0) {
                    	this.shopprice = Number(res.data.result)
						let peisongMsg = '配送费' + this.shopprice + '元'
						this.checkTips(peisongMsg, "warning")
                		this.payprice = this.totalprice * 100 + this.shopprice * 100
						this.payprice = this.payprice / 100
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
            }
			this.peisong_type = val
        },
        getBalance() {
            this.$api.order.UserBalances().then(res => {
                if (res.data.code == 0) {
                    this.myBalance = res.data.result
                } else {
                    let name = res.data.message
                    this.checkTips(name, "warning")
                }
            })
        },
        typeClick(val) {
            this.paly_type = val
            if (val == 3) {
                this.peisong_type = ''
                this.shopprice = 0
            }
        },
		// 获取用户点击去支付跳转过来的支付二维码
		getCode() {
			let code = localStorage.getItem("code")
			let type = this.$route.query.type
			if (code != "" && type == 1) {
				this.btnFlag = false
				this.submitFlag = true
				this.qr_text = code
			}
		},
		//计算总价
		getAllPrice() {
			let allPrice = 0
            let integralAllSum = 0
            let count = []
            let newPayprice = 0
			// chooseList.forEach(val => {
			// 	allPrice = allPrice + Number(val.allPrice)
			// 	console.log(allPrice)
			// })
			// // console.log(allPrice)
			// this.totalprice = allPrice.toFixed(2)
			// this.payprice = (allPrice + this.sendprice).toFixed(2)
			for (let i = 0; i < this.orderList.length; i++) {
                if (this.orderList[i].v_discountPrice) this.orderList[i]['v_minute_price'] = this.orderList[i].v_discountPrice
                if (this.orderList[i].goodsType == 2) count.push(1)
                if (this.orderList[i].goodsType == 2) this.orderList[i].v_integralSum = this.orderList[i].integral * this.orderList[i].num
				this.orderList[i].v_summation = this.orderList[i].v_minute_price * this.orderList[i].num

			}
			for (let j = 0; j < this.orderList.length; j++) {
				allPrice = this.orderList[j].v_summation + allPrice
                if (this.orderList[j].goodsType == 2) integralAllSum = this.orderList[j].v_integralSum + integralAllSum
			}
			this.payprice = allPrice + this.sendprice * 100
			this.payprice = this.payprice / 100
            this.payprice = this.payprice.toFixed(2)
			this.totalprice = allPrice / 100
            this.totalprice = this.totalprice.toFixed(2)

            // [补充] +--------------------------------------
            newPayprice = this.payprice * 100 + this.shopprice * 100
            this.payprice = newPayprice / 100
            
            this.integralAllSum = integralAllSum

            if (count.length == this.orderList.length) this.is_integral = true
		},
		paySuccess() {
			//点击支付完成跳转支付成功页面
			this.$router.push({
				path: "/paysuccess"
			})
		},
		// chooseAddress(id, name, phone, address) {
		chooseAddress(id, index) {
			this.act_addressId = id
			for (let i = 0; i < this.addressList.length; i++) {
				if (this.addressList[i].v_act) this.addressList[i].v_act = false
				if (i === index) this.addressList[i].v_act = true
			}

			//选择地址
			// this.chooseFlag = true
			// this.addressFlag = true
			// this.username = name
			// this.userphone = phone
			// this.address = address
			// localStorage.setItem("addressId", id)
			// this.getaddress(1)
		},
		all_address() {
			//展示所有地址
			this.getaddress(this.pagesize)
			this.chooseFlag = false
			// this.moreFlag = false;
		},
		getaddress(pagesize) {
			//获取收货地址
			this.$loading()
			let params = {
				PageSize: pagesize,
				PageNo: 1
			}
			this.$api.order.getAddress(params).then(res => {
				this.$loading().close()
				if (res.data.code == 0) {
					let listData = res.data.result.data
					let sortData = []
					for (let i = 0; i < listData.length; i++) {
						if (listData[i].isDefault) {
							listData[i]["v_act"] = true
							this.act_addressId = listData[i].id
							sortData.push(listData[i])
						}
					}

					for (let j = 0; j < listData.length; j++) {
						if (!listData[j].isDefault) {
							listData[j]["v_act"] = false
							sortData.push(listData[j])
						}
					}

					this.addressList = sortData

					let length = res.data.result.totalCount
					this.pagesize = length
					this.totalLength = length
					if (this.addressList.length > 0) {
						let addressId = res.data.result.data[0].id
						this.addressIds = addressId
					}
					if (length > 1 && this.addressList.length != length) {
						this.moreFlag = true
					} else {
						this.moreFlag = false
					}

					// this.newAddressListObj = this.addressList[0]
					this.newAddressListObj = JSON.parse(localStorage.getItem("AddressActObj"))
				} else {
					let name = res.data.message
					this.checkTips(name, "warning")
				}
			})
		},
		checkTips(name, type) {
			//用户提示
			this.$message({
				message: name,
				type: type
			})
		},
        wjpasswordClick() {    
            this.$router.push(
            {
                path: "/order?index=0&personal=4"
            } )
        },
        closePopupImgClick() {
            this.msg = ''
            this.is_zhifuPopup = false
            this.is_loading = false
        },
        focus(){
            this.$refs.pwd.focus();
        },
        checkClick() {
            this.is_loading = true
            let params = {PayPwd: this.msg}
            this.$api.product.VerifyPayPwd(params).then((res) => {
                if ( res.data.code == 0 )
                {
                    this.palyOrderFn()
                }else
                {
                    let name = res.data.message;
                    this.checkTips( name, 'warning' );
                    this.is_loading = false
                }
            })
        },
		immediatelyPay() {
			//提交订单信息
			// let addressId = localStorage.getItem("addressId")
			// if (this.addressFlag) {
			// 	this.addressId = parseInt(addressId)
			// } else {
			// 	this.addressId = this.addressIds
			// }
			this.addressId = this.act_addressId

			if (this.token == "" || this.token == null) {
				let name = "登录后才能购买!"
				this.checkTips(name, "warning")
			} else if (this.addressId == 0) {
				let name = "请选择收货地址!"
				this.checkTips(name, "warning")
            } else if (!this.peisong_type && this.paly_type !== 3) {
				let name = "请选择配送方式!"
				this.checkTips(name, "warning")
            } else if (!this.paly_type) {
                this.checkTips("请选择支付类型", "warning")
			} else {

				console.log(this.orderList, 'qqqq')
				// bug 修复
				for (let i = 0; i < this.payList.length; i++) {
					let shop_car_id = this.payList[i].shop_car_id
					for (let j = 0; j < this.orderList.length; j++) {
						let id = this.orderList[j].id
						if (shop_car_id === id) {
							this.payList[i].num = this.orderList[j].num
                            this.payList[i].discount_price = this.orderList[j].discountPrice
                        }
					}
				}
				console.log(this.payList, 'wwwww')
                // ! 余额支付
                if (this.paly_type == 2) {
                    if (this.payprice > this.myBalance.balance) {
                        this.checkTips("应付金额不可大于可用余额", "warning")
                        return
                    }
                    this.is_zhifuPopup = true
                    return
                }

                // ! 积分支付
                if (this.paly_type == 3) {
                    if (this.integralAllSum > this.myBalance.tokenmoney) {
                        this.checkTips("应付积分不可大于可用积分", "warning")
                        return
                    }
                    this.is_zhifuPopup = true
                    return
                }

                // ! 消费券支付
                if (this.paly_type == 5) {
                    if (this.payprice > this.myBalance.vouchers) {
                        this.checkTips("应付金额不可大于可用消费券金额", "warning")
                        return
                    }
                    this.is_zhifuPopup = true
                    return
                }

                // ! 通用券支付
                if (this.paly_type == 6) {
                    if (this.payprice > this.myBalance.generalvolume) {
                        this.checkTips("应付金额不可大于可用通用券金额", "warning")
                        return
                    }
                    this.is_zhifuPopup = true
                    return
                }

                // ! 扫码支付

				this.$loading()
				this.palyOrderFn()
			}
		},
        palyOrderFn() {
            if (this.paly_type == 3 || this.is_integral) {
                let par_data = {
                    paytype: this.paly_type,
                    user_address_id: this.addressId,
                    OrderDetails: this.payList,
                    sumprice: Number(this.totalprice),
                    sumintegral: Number(this.integralAllSum)
                }
                this.$api.order.AddOrderByIntegralGood(par_data).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        localStorage.setItem("personal", 8)
                        if (this.paly_type == 1) {
                            this.submitFlag = true
                            this.qr_text = res.data.result
                        } else if (this.paly_type == 2) {
                            this.paySuccess()
                        } else if (this.paly_type == 3 || this.paly_type == 5 || this.paly_type == 6) {
                            this.paySuccess()
                        }
                        
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })

                return
            }
            let marVal = 0
			let marketActObj = JSON.parse(localStorage.getItem("marketActObj"))
			if (marketActObj) marVal = marketActObj.lng + ',' + marketActObj.lat
			let AddressActObj = JSON.parse(localStorage.getItem("AddressActObj"))

            let peisongTypeValue = this.peisong_type == 1?0:1 // 配送方式
            let params = {
                user_address_id: this.addressId,
                OrderDetails: this.payList,
                paytype: this.paly_type,
                sumprice: Number(this.totalprice),
                type: peisongTypeValue,
                delivery_money: this.peisong_type == 2?Number(this.shopprice):0,
				user_lng_lat: AddressActObj.lngLat,
				vegetable_market_lng_lat: marVal,
                categorytype: this.orderList[0].categoryType
            }

            // 名小吃、本地小吃 追加参数 +------------------------------
            if (this.orderList[0].categoryType == 4 || this.orderList[0].categoryType == 5) {
                params.vegetable_market_lng_lat = ''
                if (this.orderList.length == 1) {
                    params['shop_lng_lat'] = this.orderList[0].shopLngLat
                } else {
                    params['shop_lng_lat'] = this.orderList[0].shopLngLat // ??? 【BUG】商家经纬度, 购物车过来的话, 多个商品 它会是同一家店铺的吗？
                }
                params['remark'] = this.remark_value
                params['istableware'] = this.istableware
                params['tablewarenum'] = this.tableware_value
            }
            // +---------------------------------------------
            this.$api.order.getPayqrcode(params).then(res => {
                this.$loading().close()
                if (res.data.code == 0) {
                    localStorage.setItem("personal", 0)
                    if (this.paly_type == 1) {
                        this.submitFlag = true
                        this.qr_text = res.data.result
                        // const qrcode = new QRCode( 'qrcode',
                        // {
                        //     width: 150, // 二维码宽度
                        //     height: 150, // 二维码高度
                        //     text: res.data.result
                        // } )
                    } else if (this.paly_type == 2 || this.paly_type == 5) {
                        this.paySuccess()
                    }
                    
                } else {
                    let name = res.data.message
                    this.checkTips(name, "warning")
                }
            })
        },
		getorderInfo() {
			//获取立即下单的订单信息
			let data = JSON.parse(localStorage.getItem("goodInfo"))
			let that = this
			that.orderList = data
            if (data[0].categoryType == 4 || data[0].categoryType == 5) this.is_categoryTypeFour = true
			that.orderList.forEach(function(res, index) {
				let price = Number(res.price) + Number(that.shopprice)
				that.totalprice = price.toFixed(2)
				that.payList.push({
					shop_car_id: res.id, //没有值就传0 购物车ID
					shop_id: res.shopId, //店铺id
					shop_good_id: res.shopGoodsId, //商品ID
					price: Number(res.price),
					num: res.num,
                    shop_type: res.shopType,
                    shop_good_type: res.goodsType, //1普通 2积分兑换
                    integral: res.integral,
                    discount_price: res.discountPrice, //折扣价
                    banJia: res.banJia,
                    shop_good_name: res.name
				})
			})

			// 新增代码 +-----------------------------------------------------
			for (let i = 0; i < that.orderList.length; i++) {
                if (that.orderList[i].shopType == 1) {
                    that.orderList[i].allPrice = (that.orderList[i].v_minute_price * that.orderList[i].num) / 100
                } else if (that.orderList[i].shopType == 2) {
                    that.orderList[i].allPrice = (that.orderList[i].v_discountPrice * that.orderList[i].num) / 100
                }
			}
		},
		add(item, index) {
			item.num++

			this.orderList[index].num = item.num
            if (this.orderList[index].shopType == 1) {
                this.orderList[index].allPrice = (this.orderList[index].v_minute_price * this.orderList[index].num) / 100
            } else if (this.orderList[index].shopType == 2) {
                this.orderList[index].allPrice = (this.orderList[index].v_discountPrice * this.orderList[index].num) / 100
            }
			
            this.orderList[index].allPrice = this.orderList[index].allPrice.toFixed(2)

			this.getAllPrice()
			// this.$set(
			// 	this.orderList[index],
			// 	"allPrice",
			// 	(this.orderList[index].price * item.num).toFixed(2)
			// )
			// let allPrice = 0
			// this.orderList.forEach((val, index) => {
			// 	allPrice = allPrice + Number(val.allPrice)
			// 	// console.log(val)
			// 	this.$set(this.payList[index], "num", item.num)
			// })
			// this.totalprice = allPrice.toFixed(2) //商品金额
			// this.payprice = (allPrice + this.sendprice).toFixed(2)
		},
		less(item, index) {
			if (item.num > 1) {
				item.num--

				this.orderList[index].num = item.num
				if (this.orderList[index].shopType == 1) {
                    this.orderList[index].allPrice = (this.orderList[index].v_minute_price * this.orderList[index].num) / 100
                } else if (this.orderList[index].shopType == 2) {
                    this.orderList[index].allPrice = (this.orderList[index].v_discountPrice * this.orderList[index].num) / 100
                }
                this.orderList[index].allPrice = this.orderList[index].allPrice.toFixed(2)
				this.getAllPrice()
				// this.$set(
				// 	this.orderList[index],
				// 	"allPrice",
				// 	(this.orderList[index].price * item.num).toFixed(2)
				// )
				// let allPrice = 0
				// // this.getorderInfo();
				// this.orderList.forEach(val => {
				// 	allPrice = allPrice + Number(val.allPrice)
				// 	this.$set(this.payList[index], "num", item.num)
				// 	// console.log(allPrice)
				// })
				// // console.log(allPrice)
				// this.totalprice = allPrice.toFixed(2) //商品金额
				// this.payprice = (allPrice + this.sendprice).toFixed(2)
			} else {
				let name = "最少选择一件商品!"
				this.checkTips(name, "warning")
			}
		},
		closeCode() {
			//关闭二维码弹窗
			this.submitFlag = false
		},
		add_address() {
			localStorage.setItem("personal", 5)
			this.$router.push({
				path: "/order?index=0&personal=5"
			})
		}
	}
}
</script>

<style scoped="scoped">
.order-but-peisong{cursor: pointer; width: 217px;height: 100px;text-align: center;line-height: 100px;border-radius: 10px 10px 10px 10px;opacity: 1;border: 1px solid #98A39C}
.order-but-act-bac{background: #26BE57;border: 1px solid #26BE57;color:#ffffff}
.order-but-ride{width:20px;height:20px;margin:auto 0}
.order-but-box{width: 160px;height: 48px;border: 1px solid #CACACA;border-radius: 10px;padding:0 27px;cursor: pointer;}
.order-but-box-p{line-height: 46px;font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #434343;}
.order-info-new-box-p {font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #000000;}
.order-but-act{border:1px solid #1DDB70;color:#1DDB70} .order-but-act-col{color:#1DDB70}
.tableware-textarea-box >>> .el-textarea__inner {background-color: #FAFAFA !important;}
.success-btn {
	width: 9.375rem;
	height: 1.875rem;
	text-align: center;
	line-height: 1.875rem;
	margin: 0 auto 0 auto;
	background-color: #37a115;
	color: #ffffff;
	font-size: 14px;
	border-radius: 0.3125rem;
	cursor: pointer;
}

.soon-pay-btn {
	width: 13.0625rem;
	height: 3.125rem;
	text-align: center;
	line-height: 3.125rem;
	color: #ffffff;
	font-size: 18px;
	background-color: #d43737;
	/* margin-left: 2.6875rem;
	margin-top: 2.5rem; */
	cursor: pointer;
}

.submit-box {
	width: 65.625rem;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 3.125rem;
}

.pay-code {
	width: 9.375rem;
	height: 9.375rem;
	/* border: 1px solid #FF0000; */
	/* border-radius: 10px; */
	margin: 1.5rem auto 0 auto;
	overflow: hidden;
}

.paytype-item img:nth-of-type(1) {
	width: 5.75rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(2) {
	width: 3.4375rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(3) {
	width: 3.5625rem;
}

.paytype-item img {
	height: 1.125rem;
}

.paytype-item {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.875rem;
}

.pay-code-tips {
	margin-top: 1.875rem;
	color: #191919;
	font-size: 17px;
	text-align: center;
}

.pay-code-price span {
	color: #37a115;
	font-weight: bold;
	font-size: 2.125rem;
}

.pay-code-price {
	font-size: 24px;
	color: #191919;
	margin-top: 1.25rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-code-top p:nth-of-type(2) {
	font-size: 28px;
	cursor: pointer;
}

.pay-code-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #191919;
	font-size: 1rem;
}

.pay-code-content {
	width: 29.375rem;
	height: 27.5rem;
	background-color: #ffffff;
	border-radius: 0.625rem;
	border: 4px solid #b3b3b3;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0 0.4375rem;
}

.pay-code-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 10;
}

.submit-box {
	width: 65.625rem;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 3.125rem;
}

.goods-price-right span {
	color: #d43737;
	font-size: 1.5rem;
	font-weight: bold;
}

.goods-price-right {
	color: #333333;
	font-size: 18px;
	font-weight: 400;
}

.goods-price-left p:nth-of-type(2) {
	margin-left: 2.9375rem;
}

.goods-price-left span {
	color: #333333;
}

.goods-price-left p {
	color: #999999;
	font-size: 0.875rem;
	font-weight: 400;
}

.goods-price-left {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.goods-price-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 0.875rem;
}

.goods-line {
	width: 100%;
	height: 1px;
	background-color: #9a9a9a;
	margin-top: 0.625rem;
}

.goods-cz span {
	display: inline-block;
	width: 0.625rem;
	height: 0.625rem;
	border-top: 1px solid #999999;
	border-right: 1px solid #999999;
	transform: rotate(-45deg);
	margin-left: 0.625rem;
	margin-bottom: 2px;
}

.goods-cz {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	text-align: center;
	margin: auto;
	color: #666666;
	font-size: 1rem;
	cursor: pointer;
}

.goods-count-box span {
	font-size: 22px;
	color: #cd3e3b;
}

.goods-count-box {
	width: 13.625rem;
	color: #999999;
	font-size: 1rem;
	text-align: center;
}

input {
	-moz-appearance: none !important;
	outline: none !important;
	-moz-outline: none !important;
}

.goods-num-box input {
	width: 1.875rem;
	height: 1.25rem;
	text-align: center;
	font-size: 14px;
	color: #000000;
	border: none;
	border-top: 1px solid #d8d8d8;
	border-bottom: 1px solid #d8d8d8;
	/* margin: 0 0.625rem; */
}

.goods-jian {
	margin-left: 0.3125rem;
}

.goods-jian,
.goods-add {
	width: 0.875rem;
	height: 0.875rem;
	border: 1px solid #d8d8d8;
	line-height: 0.75rem;
	text-align: center;
	cursor: pointer;
}

.goods-num-box {
	width: 14.75rem;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	/* border-right: 1px dashed #e2e2e2; */
	color: #999999;
	font-size: 1rem;
}

.goods-price {
	width: 12.75rem;
	height: auto;
	text-align: center;
	/* line-height: 3.125rem; */
	color: #000000;
	font-size: 1rem;
	/* border-right: 1px dashed #e2e2e2; */
}

.goods-name {
	width: 25rem;
	height: 3.125rem;
	color: #000000;
	font-size: 1rem;
	font-weight: 400;
	line-height: 3.125rem;
	padding-left: 20px;
	/* text-align: center; */
	/* border-right: 1px dashed #e2e2e2; */
}

.goods-img img {
	width: 100px;
	height: 100px;
}

.goods-img {
	width: 100px;
	height: auto;
	text-align: center;
	/* border-right: 1px dashed #e2e2e2; */
}

.goods-info-item {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #f5f5f5;
}

.choose-paytype-box {
	width: 65.625rem;
}

.choose-payType-tips {
	color: #4b4b4b;
	font-size: 16px;
	font-weight: 400;
	margin-top: 1.5625rem;
	margin-bottom: 2.1875rem;
	padding-left: 1rem;
}

.address-more {
	color: #979797;
	font-size: 12px;
	font-weight: 400;
	padding-left: 1.25rem;
	cursor: pointer;
}

.receiver-detail-address:hover {
	color: #069338;
}

.receiver-detail-address {
	color: #4d4d4d;
	cursor: pointer;
	font-size: 16px;
	font-weight: 400;
	padding-left: 2.5rem;
	margin-bottom: 1.25rem;
}

.info-tips-right {
	color: #37a115;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
}

.info-tips-left {
	font-size: 14px;
	color: #000000;
	font-weight: bold;
}

.receiver-info-tips {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.25rem;
}

.receiver-info-box {
	/* width: 62.375rem; */
	height: auto;
	/* border: 1px solid #989898; */
	/* margin-left: 1rem; */
	margin-top: 0.8125rem;
	/* padding: 0.625rem 1.25rem 1.25rem 1.25rem; */
}

.myfoods-user-box {
	color: #4b4b4b;
	font-size: 1rem;
	font-weight: 400;
	margin-top: 2.5rem;
	padding-left: 1rem;
}

.order-info {
	/* font-size: 1.125rem; */
	color: #333333;
	font-weight: 400;
	font-size: 24px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #333333;
	line-height: 34px;
}

.myfoods-pay-box {
	width: 75rem;
	margin: auto;
	/* padding-left: 1.25rem; */
	padding-top: 1rem;
	padding-bottom: 20px;
}
/*++++++++++++++++++++++++++++++++++++++++++++*/
.pay-code {
	width: 9.375rem;
	height: 9.375rem;
	border: 1px solid #ff0000;
	border-radius: 10px;
	margin: 1.5rem auto 0 auto;
}

.paytype-item img:nth-of-type(1) {
	width: 5.75rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(2) {
	width: 3.4375rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(3) {
	width: 3.5625rem;
}

.paytype-item img {
	height: 1.125rem;
}

.paytype-item {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.875rem;
}

.pay-code-tips {
	margin-top: 3.125rem;
	color: #191919;
	font-size: 17px;
	text-align: center;
}

.pay-code-price span {
	color: #37a115;
	font-weight: bold;
	font-size: 2.125rem;
}

.pay-code-price {
	font-size: 24px;
	color: #191919;
	margin-top: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-code-top p:nth-of-type(2) {
	font-size: 28px;
	cursor: pointer;
}

.pay-code-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #191919;
	font-size: 1rem;
}

.pay-code-content {
	width: 29.375rem;
	height: 27.5rem;
	background-color: #ffffff;
	border-radius: 0.625rem;
	border: 4px solid #b3b3b3;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0 0.4375rem;
}

.pay-code-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 10;
}

.submit-box {
	width: 65.625rem;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 3.125rem;
}

.goods-price-right span {
	color: #d43737;
	font-size: 1.5rem;
	font-weight: bold;
}

.goods-price-right {
	color: #333333;
	font-size: 18px;
	font-weight: 400;
}

.goods-price-left p:nth-of-type(2) {
	margin-left: 2.9375rem;
}

.goods-price-left span {
	color: #333333;
}

.goods-price-left p {
	color: #999999;
	font-size: 0.875rem;
	font-weight: 400;
}

.goods-price-left {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.goods-price-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 0.875rem;
}

.goods-line {
	width: 100%;
	height: 1px;
	background-color: #9a9a9a;
	margin-top: 0.625rem;
}

.goods-cz span {
	display: inline-block;
	width: 0.625rem;
	height: 0.625rem;
	border-top: 1px solid #999999;
	border-right: 1px solid #999999;
	transform: rotate(-45deg);
	margin-left: 0.625rem;
	margin-bottom: 2px;
}

.goods-cz {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	text-align: center;
	margin: auto;
	color: #666666;
	font-size: 1rem;
	cursor: pointer;
}

.goods-count-box span {
	font-size: 22px;
	color: #cd3e3b;
}

.goods-count-box {
	width: 13.625rem;
	color: #999999;
	font-size: 1rem;
	text-align: center;
}

input {
	-moz-appearance: none !important;
	outline: none !important;
	-moz-outline: none !important;
}

.goods-jian {
	margin-left: 0.3125rem;
}

.goods-jian,
.goods-add {
	width: 1.25rem;
	height: 1.25rem;
	border: 1px solid #d8d8d8;
	line-height: 1.1rem;
	text-align: center;
	cursor: pointer;
}

.myfoods-pay-box {
	width: 75rem;
	margin: auto;
	padding-left: 1.25rem;
	padding-top: 1rem;
}

.order-info {
	font-size: 1.125rem;
	color: #333333;
	font-weight: 400;
}

.ok_img {
	width: 0.5625rem;
	height: 0.5625rem;
	position: absolute;
	top: 0.125rem;
	right: 0.125rem;
}

.choose-type {
	position: absolute;
	top: 0;
	right: 0;
	width: 0;
	height: 0;
	border-top: 1.4375rem solid #37a115;
	border-left: 1.5625rem solid transparent;
}

.choose-paytype-item {
	position: relative;
	cursor: pointer;
	margin-right: 2.1875rem;
}

.choose-paytype-item,
.choose-paytype-item img:nth-of-type(2) {
	width: 8.75rem;
	height: 3.0625rem;
}

.choose-paytype-box {
	width: 65.625rem;
}

.choose-payType-tips {
	color: #4b4b4b;
	font-size: 16px;
	font-weight: 400;
	margin-top: 1.5625rem;
	margin-bottom: 2.1875rem;
	padding-left: 1rem;
}

.address-more {
	color: #979797;
	font-size: 12px;
	font-weight: 400;
	padding-left: 1.25rem;
	cursor: pointer;
}

.receiver-detail-address {
	color: #4d4d4d;
	font-size: 16px;
	font-weight: 400;
	padding-left: 2.5rem;
	margin-bottom: 1.25rem;
}

.info-tips-right {
	color: #37a115;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
}

.info-tips-left {
	font-size: 14px;
	color: #000000;
	font-weight: bold;
}

.receiver-info-tips {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.25rem;
}

.receiver-info-box {
	/* width: 62.375rem;
	height: 8.3125rem;
	border: 1px solid #989898;
	margin-left: 1rem; */
	margin-top: 0.8125rem;
	padding: 0.625rem 0 0 0;
}

.myfoods-user-box {
	margin-top: 2.5rem;
	padding-left: 1rem;
}

.myfoods-user-box {
	color: #4b4b4b;
	font-size: 1rem;
	font-weight: 400;
}

.mycart-container-item {
	width: 100%;
	height: auto;
	min-height: 25rem;
	background-color: #ffffff;
	padding: 0 20px;
	margin-bottom: 60px;
}

.gopage_index {
	width: 2.5rem;
	height: 27px;
	text-align: center;
	line-height: 25px;
	margin-left: 5px;
	cursor: pointer;
	font-size: 12px;
	font-family: Microsoft YaHei UI;
	font-weight: 400;
	color: #97989d;
	background: #ffffff;
	border: 1px solid #e3e3e3;
	border-radius: 5px;
}

.mycart-pay {
	width: 140px;
	height: 58px;
	text-align: center;
	line-height: 58px;
	background-color: #d43737;
	color: #ffffff;
	font-size: 18px;
	cursor: pointer;
}

.mycart-footer {
	/* display: flex;
        align-items: center;
        justify-content: space-between; */
	margin-top: 0rem;
}

.mycart-page-index {
	width: 2.5rem;
	height: 34px;
	text-align: center;
	line-height: 34px;
	font-size: 12px;
	font-family: Microsoft YaHei UI;
	font-weight: 400;
	color: #97989d;
	background: #ffffff;
	border: 1px solid #e3e3e3;
	border-radius: 5px;
	cursor: pointer;
}

.mycart-page {
	/* width: 60%; */
	display: flex;
	align-items: center;
	margin: 40px 0;
}

.mycart-page
	>>> .el-pagination.is-background
	.el-pager
	li:not(.disabled).active {
	background-color: #07762e;
	color: #fff;
}

.mycart-page >>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
	margin: 0 5px;
	background-color: #ffffff;
	color: #97989d;
	min-width: 30px;
	border-radius: 2px;
}

.foods-factprice span {
	color: #d43737;
	font-size: 24px;
}

.foods-factprice {
	color: #333333;
	font-size: 18px;
	font-weight: 400;
	text-align: right;
	padding-right: 78px;
	line-height: 58px;
	/* margin-top: 3.75rem; */
}

.mycart-btm-price {
	margin-left: 2.5rem;
}

.mycart-btm-info span {
	color: #333333;
}

.mycart-btm-info {
	display: flex;
	align-items: center;
	color: #999999;
	font-size: 14px;
	font-weight: 400;
}

.mycart-btm-del {
	/* width: 7.3125rem; */
	/* height: 1.5625rem; */
	/* text-align: center; */
	line-height: 58px;
	/* border: 1px solid #627D4D; */
	cursor: pointer;
	color: #999999;
	font-size: 14px;
	margin-left: 20px;
}

.mycart-btm-box {
	width: 100%;
	display: flex;
	height: 1.875rem;
	align-items: center;
	justify-content: space-between;
	margin-top: 1.25rem;
	padding-left: 1.875rem;
	padding-right: 1.25rem;
}

.mycart-item-delete {
	width: 9rem;
	height: 170px;
	/* margin: auto; */
	text-align: right;
	padding-right: 24px;
	cursor: pointer;
}

.mycart-item-subtotal {
	width: 8.125rem;
	height: 170px;
	color: #bc0000;
}

.mycart-item-num {
	width: 13.125rem;
	height: 170px;
	display: flex;
	/* align-items: center; */
	justify-content: center;
}

.mycart-item-price p:nth-of-type(1) {
	color: #bc0000;
}

.mycart-item-price p:nth-of-type(2) {
	color: #999999;
	font-size: 12px;
	margin-top: 2px;
}

.mycart-item-price {
	width: 7.6875rem;
	height: 170px;
	/* display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center; */
}

.mycart-item-name {
	width: 8.9375rem;
}

.mycart-item-img img {
	width: 6.125rem;
	height: 6.125rem;
	margin: 36px 0;
}

.mycart-item-img {
	width: 32.25rem;
	/* padding-top: 0.125rem; */
}

.mycart-line {
	width: 1px;
	height: 3.125rem;
	background-color: #e2e2e2;
}

.mycart-foods-item {
	text-align: center;
	display: flex;
	align-items: center;
	/* height: 5.57rem; */
	border-bottom: 1px solid #f5f5f5;
	color: #333333;
	font-size: 14px;
	font-weight: 400;
}

.mycart-foods-delete {
	width: 9rem;
	text-align: right;
	padding-right: 24px;
}

.mycart-subtotal {
	width: 9.5rem;
}

.mycart-foods-num {
	width: 19rem;
}

.mycart-foods-price {
	width: 7.75rem;
}

.mycart-foods-name {
	width: 9rem;
}

.mycart-product {
	width: 26rem;
	line-height: 58px;
}

.mycart-item-index {
	width: 2.625rem;
	text-align: left;
}

.mycart-item-index input {
	border: 1px solid red;
	width: 20px;
	height: 20px;
}

.mycart-index {
	width: 2rem;
	text-align: left;
	/* padding-left: 1.8rem */
}

.mycart-index input {
	width: 1.25rem;
	height: 1.25rem;
	background-color: #ffffff;
	color: #000000;
}

.mysave-input input:disabled {
	background-color: #ffffff;
}

.mysave-input input {
	/* border: 1px solid #CFCFCF; */
	border: none;
	border-top: 1px solid #cfcfcf;
	border-bottom: 1px solid #cfcfcf;
	outline: none;
}

.mysave-input {
	/* margin: 0 5px; */
	margin: 0;
}

.mysave-input,
.mysave-input input {
	width: 2.25rem;
	height: 1.3125rem;
	text-align: center;
	color: #333333;
	font-size: 16px;
}

.mysave-less,
.mysave-add {
	width: 1.3125rem;
	height: 1.3125rem;
	/* border-radius: 50%; */
	border: 1px solid #cfcfcf;
	text-align: center;
	line-height: 1.1rem;
	color: #333333;
	font-size: 16px;
	cursor: pointer;
	background-color: #f8f8f8;
	margin-top: 1px;
}

.mycart-index,
.mycart-product,
.mycart-foods-name,
.mycart-foods-price,
.mycart-foods-num,
.mycart-subtotal {
	border-right: 1px solid #ffffff;
}

.mycart-header-box {
	display: flex;
	align-items: center;
	width: 100%;
	/* height: 2.625rem; */
	background-color: #ffffff;
	font-size: 14px;
	color: #333333;
	font-weight: 400;
	text-align: center;
	margin-top: 0.5rem;
	border-bottom: 1px solid #f5f5f5;
	/* padding: 20px 0; */
	box-sizing: border-box;
}

.mycart-top-right span {
	color: #333333;
	margin: 0 5px;
}

.mycart-top-right {
	color: #999999;
	font-size: 14px;
	font-weight: 400;
	line-height: 58px;
	margin-right: 23px;
}

.mycart-top-left span {
	display: inline-block;
	width: 6px;
	height: 24px;
	background-color: #82ba55;
	margin-right: 0.625rem;
}

.mycart-top-left {
	color: #333333;
	font-size: 16px;
	font-weight: 400;
	display: flex;
	align-items: center;
}

.mycart-top-box {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 1.125rem;
}

.shopcart-tips p:nth-of-type(1) {
	color: #333333;
	font-size: 18px;
	font-weight: 400;
	cursor: pointer;
}

.shopcart-tips p:nth-of-type(2) {
	color: #999999;
	font-size: 14px;
	font-weight: 400;
	cursor: pointer;
}

.shopcart-tips {
	padding-left: 1rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.shopcart-box {
	width: 75rem;
	height: auto;
	margin: auto;
	padding-top: 0.5rem;
}

.shopcart-bigbox {
	width: 100%;
	height: auto;
	min-height: 49.6875rem;
	border-bottom: 1px solid #e7e7e7;
}

.product-nofoods {
	font-size: 24px;
	color: #595757;
	font-weight: 400;
}

.mycart-no-tips {
	width: 75rem;
	margin: auto;
	/* padding-left: 1rem; */
	font-size: 12px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #999999;
	line-height: 34px;
}

.sho_box {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
}

.sho_cent {
	width: 100%;
	height: 32.4375rem;
	background: #f2f2f2;
	position: relative;
	padding-top: 0.5rem;
}

.sho_cents {
	display: flex;
	justify-content: center;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	/* padding-top: 5rem; */
}

.sho_cents img {
	width: 14rem;
	height: 11.625rem;
}

.sho_centstest h3 {
	font-size: 24px;
	font-family: Microsoft YaHei UI;
	font-weight: 400;
	color: #595757;
}

.sho_centstest p {
	font-size: 14px;
	font-family: Microsoft YaHei UI;
	font-weight: 400;
	color: #999999;
	margin-top: 0.5rem;
}

.sho_centstest span {
	cursor: pointer;
}

.sho_centstest {
	margin-top: 4.375rem;
	margin-left: 1.875rem;
}

.shopping-p {
	font-size: 12px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #434343;
	line-height: 34px;
}

.shopping-now-bac {
	background-color: #c1c1c1;
}

.shopping-jsact {
	background-color: #d9161c;
}

.list-page >>> .el-pagination .btn-prev {
	padding-right: 12px;
	padding-left: 12px;
	width: 2rem;
	margin-right: 8px;
	color: #97989d;
}

.list-page >>> .el-pagination .btn-next {
	padding-left: 12px;
	padding-right: 12px;
	width: 2rem;
	/* margin-left: 8px; */
	color: #97989d;
}

.shopping-jump-input >>> .el-input__inner {
	height: 34px;
	width: 2.3rem;
	text-align: center;
	padding: 0 5px;
}

@import "../../assets/style/base.css";
.userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
     #payPwd .pwd-wrap{
    /* width: 90%; */
    height: 44px;
    padding-bottom: 1px;
    margin: 0 auto;
    background: #fff;
    /* border:1px solid #ddd; */
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    cursor: pointer;
  }
  .pwd-wrap li{
    list-style-type:none;
    text-align: center;
    line-height: 44px;
    -webkit-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
    /* border-right:1px solid #ddd ; */
    background: #f2f2f2;
    margin: 0 10px;
  }
  .pwd-wrap li:last-child{
    border-right: 0;
  }
  .pwd-wrap li i{
    height: 10px;
    width: 10px;
    border-radius:50% ;
    background: #000;
    display: inline-block;
  }
</style>